import { useCallback, useEffect, useState, RefObject } from "react";
import { useResizeObserver } from "@react-aria/utils";

const useTableWidth = (
  tableRef: RefObject<HTMLDivElement | null> | undefined,
  active: boolean
): number | undefined => {
  const [tableWidth, setTableWidth] = useState<number | undefined>(undefined);

  const updateWidth = useCallback(() => {
    if (active && tableRef?.current) {
      setTableWidth(tableRef.current.offsetWidth);
    }
  }, [active, tableRef]);

  useResizeObserver({ ref: tableRef, onResize: updateWidth });

  useEffect(() => {
    if (!active || !tableRef?.current) {
      return;
    }

    updateWidth();
  }, [active, tableRef, updateWidth]);

  return tableWidth;
};

export default useTableWidth;
